import React, { Component } from "react";

import moment from "moment";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import { DatePicker } from "@material-ui/pickers/DatePicker";
import CurrencyFormater from "../../../shared/ui/Currency.Input";
import ConfirmButton from "../../../common/components/ConfirmButton";

export default class TableCellLoanActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      date: new Date(),
      amount: undefined,
      fullRepaymentOpen: false,
      dateToRepay: new Date(),
    };
  }

  handleOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleFullRepaymentOpen = () => {
    this.setState({
      fullRepaymentOpen: true,
    });
  };

  handleFullRepaymentClose = () => {
    this.setState({
      fullRepaymentOpen: false,
    });
  };

  handleRepayment = () => {
    this.props.fullRepayment(
      this.props.item.Id,
      this.state.date,
      this.state.amount,
    );
    this.handleClose();
  };

  handleDateChange = (date) => {
    this.setState({
      date,
    });
  };

  handleAmountChange = (event, amount) => {
    this.setState({
      amount,
    });
  };

  handleFullRepaymentGet = () => {
    let id = Number.isInteger(this.props.item.Id)
      ? this.props.item.Id
      : this.props.item.IntId;
    this.props.getFullRepayment(id, this.state.dateToRepay);
  };

  handleDateToRepayChange = (date) => {
    this.setState({
      dateToRepay: date,
    });
  };

  render() {
    const actions = [
      <Button
        key="1"
        variant="outlined"
        color="primary"
        keyboardFocused={true}
        onClick={this.handleRepayment}
      >
        Register
      </Button>,
    ];

    const repaymentActions = [
      <Button
        key="1"
        variant="outlined"
        color="primary"
        keyboardFocused={true}
        onClick={this.handleFullRepaymentGet}
      >
        Get repayment
      </Button>,
      <Button
        key="2"
        variant="outlined"
        keyboardFocused={false}
        onClick={this.handleFullRepaymentClose}
      >
        Close
      </Button>,
    ];

    const close = [
      <Button
        key="2"
        variant="outlined"
        keyboardFocused={false}
        onClick={this.handleFullRepaymentClose}
      >
        Close
      </Button>,
    ];

    const id = Number.isInteger(this.props.item.Id)
      ? this.props.item.Id
      : this.props.item.IntId;
    const accountId = this.props.item.AccountId;
    const loanId = this.props.item.Guid;

    return (
      <div className="table-cell-actions">
        {/*<Button variant="contained" color="primary"   fullWidth={true}  onClick={this.handleOpen} >Repay</Button>*/}
        <Button
          variant="contained"
          color="primary"
          fullWidth={true}
          onClick={this.handleFullRepaymentOpen}
        >
          Get repayment
        </Button>
        <Dialog modal={false} open={this.state.open} onClose={this.handleClose}>
          <DialogTitle>Register loan repayment</DialogTitle>
          <DialogContent>
            Register loan repayment for id:{id}
            <br />
            <DatePicker
              inputVariant="outlined"
              className="small-datepicker"
              value={this.state.date}
              onChange={this.handleDateChange}
              helperText="Bank registered date"
            />
            <br />
            Amount <br />
            <CurrencyFormater
              value={this.state.amount}
              onChange={this.handleAmountChange}
              label="Amount"
            />
            <br />
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
        <Dialog
          modal={false}
          open={this.state.fullRepaymentOpen}
          onClose={this.handleFullRepaymentClose}
        >
          <DialogTitle>Get loan full repayment</DialogTitle>
          <DialogContent>
            Get loan repayment for id:{id}
            <br />
            <DatePicker
              inputVariant="outlined"
              className="small-datepicker"
              value={this.state.dateToRepay}
              onChange={this.handleDateToRepayChange}
              helperText="Bank transfer date"
            />
            <br />
            {this.props.item.fullRepaymentLoading ? (
              <CircularProgress />
            ) : this.props.item.fullRepayment &&
              this.props.item.fullRepayment.Amount ? (
              <React.Fragment>
                Summa: {this.props.item.fullRepayment.Amount.Amount}kr <br />
                OCR: {this.props.item.OCR}
                <br />
                Bankgiro: 5399-5437
                <br />
                Betalning oss tillhanda:{" "}
                {moment(this.props.item.fullRepayment.Date).format(
                  "YYYY-MM-DD",
                )}
                <br />
                {this.props.item.fullRepaymentCreatedByAdminDone && (
                  <span style={{ color: "green" }}>repayment created</span>
                )}
              </React.Fragment>
            ) : (
              <div />
            )}
            {this.props.item.fullRepayment &&
              this.props.item.fullRepayment.Amount && (
                <ConfirmButton
                  label={"Create AdHocRepayment"}
                  showContentAfterAction
                  fullWidth
                  action={() => {
                    this.props.fullRepayment(
                      loanId,
                      accountId,
                      this.state.dateToRepay,
                      this.props.item.fullRepayment.Amount.Amount,
                    );
                  }}
                >
                  {!(
                    this.props.item.fullRepaymentCreatedByAdminLoading ||
                    this.props.item.fullRepaymentCreatedByAdminDone ||
                    this.props.item.fullRepaymentCreatedByAdminError
                  ) && <span>Create adHoc repayment for user</span>}
                  {this.props.item.fullRepaymentCreatedByAdminLoading && (
                    <CircularProgress />
                  )}
                  {this.props.item.fullRepaymentCreatedByAdminDone && (
                    <span style={{ color: "green" }}>repayment created</span>
                  )}
                  {this.props.item.fullRepaymentCreatedByAdminError && (
                    <span style={{ color: "red" }}>
                      repayment creation failed
                    </span>
                  )}
                </ConfirmButton>
              )}
          </DialogContent>
          <DialogActions>
            {this.props.item.fullRepaymentCreatedByAdminDone
              ? close
              : repaymentActions}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
